import { jsxs as h, jsx as o } from "react/jsx-runtime";
import { forwardRef as g } from "react";
import { ClockIcon as b } from "../Icons/objects/ClockIcon.js";
import { Input as v } from "./Input/index.js";
import { Popover as w, PopoverButton as x, PopoverPanel as P } from "@headlessui/react";
import { Button as k } from "../Button/index.js";
import { Picker as C } from "./Picker.js";
import { validationValue as y, formatWithPattern as B } from "./tools.js";
const V = g((s, l) => {
  const {
    name: p,
    value: t,
    disabled: r,
    onChange: d,
    placeholder: c = "GG:MM",
    minutesStep: j = 1,
    onBackspaceAtEmpty: n,
    onComplete: m,
    ...f
  } = s, a = (e) => {
    d(e), m && e.length === 5 && m();
  };
  return /* @__PURE__ */ h(w, { className: "jm-relative jm-w-fit", children: [
    /* @__PURE__ */ o(
      v,
      {
        ...f,
        ref: l,
        name: p,
        value: t,
        onKeyDown: (e) => {
          n && e.key === "Backspace" && t === "" && (e.preventDefault(), n());
        },
        placeholder: c,
        disabled: r,
        maxLength: 5,
        onChange: (e) => {
          const i = e.target.value;
          if (!y(i))
            return;
          const u = B(i);
          a(u);
        },
        suffixElement: /* @__PURE__ */ o(
          x,
          {
            as: "div",
            disabled: r,
            className: "jm-border-none jm-bg-white jm-p-0 jm-text-jutro-new-blue-700 focus:jm-border-none focus:jm-outline-none disabled:jm-bg-transparent",
            children: /* @__PURE__ */ o(
              k,
              {
                tabIndex: -1,
                icon: /* @__PURE__ */ o(b, {}),
                label: "time picker",
                disabled: r,
                withTooltip: !1,
                size: "condensed",
                variant: "ghost"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      P,
      {
        anchor: "bottom",
        className: "jm-border-jutro-new-gray-500 jm-z-50 jm-grid jm-grid-cols-2 jm-gap-1 jm-overflow-hidden jm-rounded-lg jm-border jm-border-solid jm-bg-white jm-p-2",
        children: /* @__PURE__ */ o(C, { onChange: a, value: t, minutesStep: j })
      }
    )
  ] });
});
export {
  V as TimeInput
};
//# sourceMappingURL=index.js.map
